
import React from 'react';
import './Footer.scss';
import privacyData from './data.json';


type PrivacyContentItem =
  | { type: 'heading'; content: string }
  | { type: 'paragraph'; content: string }
  | { type: 'ordered-list'; items: (string | string[])[] }
  | { type: 'copyright'; content: string };

const renderContent = (content: PrivacyContentItem[]) => {
  return content.map((item: PrivacyContentItem, idx: number) => {
    switch (item.type) {
      case 'heading':
        return <h4 key={idx}>{item.content}</h4>;
      case 'paragraph':
        return <p key={idx} dangerouslySetInnerHTML={{ __html: item.content }} />;
      case 'ordered-list':
        return (
          <ol key={idx}>
            {item.items.map((li: string | string[], liIdx: number) =>
              Array.isArray(li) ? (
                <li key={liIdx}>
                  {li[0]}
                  <ul>
                    {li.slice(1).map((sub: string, subIdx: number) => (
                      <li key={subIdx}>{sub}</li>
                    ))}
                  </ul>
                </li>
              ) : (
                <li key={liIdx}>{li}</li>
              )
            )}
          </ol>
        );
      case 'copyright':
        return <p key={idx} style={{ color: 'gray', marginTop: '2rem' }}>{item.content}</p>;
      default:
        return null;
    }
  });
};


const PrivacyContent: React.FC = () => (
  <div className="privacy-content" >
    {renderContent(privacyData.privacy.content as PrivacyContentItem[])}
  </div>
);

export default PrivacyContent;
